/* eslint-disable no-unused-vars */
export enum LocalStorageKeyEnums {
    ADMIN_TOKEN = 'auth.token.admin'
}
